<button #dropdownButton
        class="navbar-status-dropdown-item link-item"
        [ngClass]="{ 'inactive': inactive, 'current': selected }"
        [attr.title]="name | translate"
        [tabindex]="dropdownButtonTabIndex"
        (click)="onItemSelect()">
  <div class="availability-icon">
    <div class="bc-status-circle" [ngClass]="{ 'available': available, 'away': away }">
      <svg-icon icon="checkmark"></svg-icon>
    </div>
  </div>
  <div class="item-text" [ngClass]="{'inactive': inactive}">{{name | translate }}</div>
</button>
